import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Client from '@spike/client-model';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren, useState } from 'react';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';

export interface ExpandableSectionProps extends PropsWithChildren {
    header: JSX.Element;
    initExpanded?: boolean;
    disableExpandable?: boolean;
    bottomPadding?: number;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: (props: { bottomPadding?: number }) => ({
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 8,
            padding: `14px 18px ${props.bottomPadding ?? 18}px 15px`,
            border: '1px solid #D4D4D4'
        }),
        header: {
            display: 'flex',
            width: '100%'
        },
        leftHeader: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1
        },
        rightHeader: {
            display: 'flex',
            cursor: 'pointer'
        },
        body: {
            display: 'flex',
            flexDirection: 'column'
        }
    })
);

export const ExpandableSection: FunctionComponent<ExpandableSectionProps> = props => {
    const classes = useStyles(props);

    const [expanded, setExpanded] = useState(props.disableExpandable ? true : props.initExpanded ?? false);

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Box className={classes.header}>
                <Box className={classes.leftHeader}>{props.header}</Box>
                {!props.disableExpandable && (
                    <Box
                        className={classes.rightHeader}
                        onClick={() => setExpanded(prev => !prev)}
                    >
                        <FontAwesomeIcon icon={expanded ? faChevronUp : faChevronDown} />
                    </Box>
                )}
            </Box>
            {expanded && <Box className={classes.body}>{props.children}</Box>}
        </Box>
    );
};

export default ExpandableSection;
